import LogRocket from "logrocket";
import $ from "jquery";

import modal from "./modules/modal";
import scrollFx from "./modules/scroll-fx";
import photoFx from "./modules/photo-fx";
import form from "./modules/form";
import layoutSwitcher from "./modules/layout-switcher";
import chart from "./modules/chart";
import clock from "./modules/clock";
import laptop from "./modules/laptop";
import nav from "./modules/nav";

require("./plugins/modernizr.js");

$(() => {
  laptop.init();
  nav.init();
  modal.init();
  form.init();
  clock.init();
  photoFx.init();
  scrollFx.init();
  layoutSwitcher.init();
  chart.init();
  const $body = $("body");
  setTimeout(() => {
    $body.addClass("body--animate-in");
  }, 100);

  $(".alert__close").on("click", function (event) {
    event.preventDefault();
    $(this).parent(".alert").slideUp("fast");
  });
});

LogRocket.init("idtal2/tublitzed");
